import React from 'react';
import { FadeInUp } from './ui/FadeInUp';
import { SectionEyebrow } from './ui/SectionEyebrow';
import { ArrowRight } from 'lucide-react';
export function AboutSection() {
  return <section className="py-24 md:py-32 bg-ivory border-t border-sand/50" data-id="element-15">
      <div className="container mx-auto px-6" data-id="element-16">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24" data-id="element-17">
          <div className="w-full lg:w-1/2 order-2 lg:order-1" data-id="element-18">
            <FadeInUp data-id="element-19">
              <div className="relative rounded-lg overflow-hidden shadow-2xl aspect-[3/4] max-w-lg mx-auto lg:mx-0" data-id="element-20">
                <img src="https://cdn.magicpatterns.com/uploads/2orc1Xvjyc5P94UymMFWJW/star-0lRNxeYfk-M-unsplash.jpg" alt="Phoenix Metro home at twilight with pool and string lights" className="w-full h-full object-cover" data-id="element-21" />
                <div className="absolute inset-0 border border-black/5 rounded-lg pointer-events-none" data-id="element-22"></div>

                {/* Brand Seal */}
                <div className="absolute -bottom-6 -right-6 md:-bottom-8 md:-right-8 w-20 h-20 md:w-24 md:h-24 bg-ivory rounded-full p-3 shadow-xl hidden sm:flex items-center justify-center" data-id="element-23">
                  <img src="https://cdn.magicpatterns.com/uploads/vNvN1XWtPWy9K7eBdDVvNB/Beshk-group-logo-icon.png" alt="The Beshk Group" className="w-full h-full object-contain" data-id="element-24" />
                </div>
              </div>
            </FadeInUp>
          </div>

          <div className="w-full lg:w-1/2 order-1 lg:order-2" data-id="element-25">
            <FadeInUp delay={0.1} data-id="element-26">
              <SectionEyebrow text="About Us" data-id="element-27" />
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-charcoal mb-8 leading-tight" data-id="element-28">
                Real estate runs in the family.
              </h2>
              <div className="text-charcoal-text/80 space-y-6 text-lg leading-relaxed mb-10" data-id="element-29">
                <p data-id="element-30">
                  John and Mickie Beshk have called Gilbert home since 1996.
                  Together, they have helped thousands of Phoenix families
                  achieve their dream of homeownership since 1992.
                </p>
                <p data-id="element-31">
                  John holds a Bachelor of Science in Finance from DePaul
                  University and an MBA from the University of Phoenix. He also
                  serves as Real Estate Program Director at Mesa Community
                  College and is certified by the Arizona Department of Real
                  Estate to teach pre-licensing courses.
                </p>
                <p data-id="element-32">
                  Mickie brings a strong background in banking and finance,
                  having served as a Relationship Banker and Loan Officer at
                  J.P. Morgan Chase and Bank of America.
                </p>
                <p data-id="element-33">
                  Outside of real estate, they volunteer at City of Grace Church
                  in Mesa and serve on the Board of Whetstone Boys Ranch.
                  Family, faith, and community come first.
                </p>
              </div>

              <a href="#" className="inline-flex items-center text-terracotta font-medium group" data-id="element-34">
                Learn More About Us
                <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" data-id="element-35" />
                <span className="absolute bottom-0 left-0 w-0 h-px bg-terracotta transition-all group-hover:w-full" data-id="element-36"></span>
              </a>

              {/* Mobile Brand Seal (shows only on small screens) */}
              <div className="mt-12 w-16 h-16 sm:hidden mx-auto" data-id="element-37">
                <img src="https://cdn.magicpatterns.com/uploads/vNvN1XWtPWy9K7eBdDVvNB/Beshk-group-logo-icon.png" alt="The Beshk Group" className="w-full h-full object-contain" data-id="element-38" />
              </div>
            </FadeInUp>
          </div>
        </div>
      </div>
    </section>;
}